import React from "react";

export const LazyAccountPage = React.lazy(
  () => import("modules/investorRole/pages/AccountsPage/AccountPage"),
);
